import React from 'react';
import IdealMembersInputSmall from 'src/molecules/Standard/NameGenerator/IdealMembersInput/IdealMembersInputSmall';
import { FromIdeaToLiveIdealMemberContainer } from './FromIdeaToLiveIdealMember.styles';
import Paragraph from 'src/elements/typography/paragraph';
import Heading from 'src/elements/typography/heading';

interface FromIdeaNameGeneratorProps {
  statsigEvent?: string;
  hintText?: string;
}

const FromIdeaToLiveIdealMember = ({
  statsigEvent = 'homepage_generator_submit',
  hintText = 'Examples: coaching clients, meditation novices, vegan chefs, dog lovers, aspiring entrepreneurs, etc.',
}: FromIdeaNameGeneratorProps): JSX.Element => {
  return (
    <FromIdeaToLiveIdealMemberContainer>
      <Heading
        standardSize='1.5'
        weight={700}
        text='Who do you want to bring together?'
      />
      <IdealMembersInputSmall
        mobileText='Go'
        generationMode='generator'
        inlineButtonOnMobile={false}
        statsigEvent={statsigEvent}
      />
      <Paragraph
        standardSize='0.75'
        text={hintText}
      />
    </FromIdeaToLiveIdealMemberContainer>
  );
};

export default FromIdeaToLiveIdealMember;
